import { render, staticRenderFns } from "./ListaOrdini.vue?vue&type=template&id=c7a9bbfe&"
import script from "./ListaOrdini.vue?vue&type=script&lang=js&"
export * from "./ListaOrdini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports